import Message from '@/components/chat/Message';
import BillingModel from '@/components/wizard/BillingModel';
import ProductPrice from '@/components/wizard/ProductPrice';

import AnswerRequest, { type AnswerRequestProps } from './AnswerRequest';
import ProducerDataBlock from './ProducerDataBlock';
import ProductAiLoadingExamples from './ProductAiLoadingExamples';
import ProductDetailsBlock from './ProductDetailsBlock';
import ProductPaymentMethods from './ProductPaymentMethods';
import QuestionRequest from './QuestionRequest';
import ReviewMode from './ReviewMode';
import SelectProduct from './SelectProduct';
import Start from './Start';
import UploadFile from './UploadFile';

export const wizardComponents = {
  empty: () => null,
  start: () => <Start />,
  chat_continue: () => <Message type='answer'>Continuar</Message>,
  chat_question_request: () => <QuestionRequest />,
  chat_answer_request: (data: AnswerRequestProps['data']) => <AnswerRequest data={data} />,
  qualification_chat_question_transition: () => <Message type='question'>Ótimo, vamos começar.</Message>,
  select_product: () => <SelectProduct />,
  product_details_ai_loading_examples: () => <ProductAiLoadingExamples />,
  product_details_ai_question: () => (
    <Message type='ai'>Perfeito, tudo que você compartilhou ajudou a gerar algumas sugestões! O que você acha?</Message>
  ),
  product_details_form_block: () => <ProductDetailsBlock />,
  billing_model_question: () => (
    <Message type='question'>Agora, vamos juntos configurar a forma que seu produto será vendido?</Message>
  ),
  billing_model_product: () => <BillingModel />,
  price_product: () => <ProductPrice />,
  payment_method_answer_type: () => <BillingModel />,
  payment_method_chat_question_1: () => (
    <Message type='question'>
      Está ficando ótimo! Mas me diz: como seus clientes poderão pagar e quais ferramentas você deseja ativar?
    </Message>
  ),
  payment_method_answer_info: () => <ProductPaymentMethods />,
  upload_chat_question_1: () => (
    <Message type='question'>
      Envie os arquivos principais do seu produto: e-books, planilhas, imagens ou qualquer outro material que seu
      cliente receberá ao comprar.
    </Message>
  ),
  upload_answer_files: () => <UploadFile />,
  producer_data_question_1: () => (
    <Message type='question'>Antes de publicar seu produto, precisamos confirmar algumas informações básicas.</Message>
  ),
  producer_data_question_2: () => (
    <Message type='question'>
      Isso garante a segurança das suas vendas e que seus recebimentos sejam feitos corretamente.
    </Message>
  ),
  producer_data_block: () => <ProducerDataBlock />,
  chat_review_product: () => (
    <Message type='question'>
      Hora de revisar! Vamos conferir os detalhes do seu produto antes de colocá-lo à venda?
    </Message>
  ),
  chat_edit_without_ia: () => (
    <Message type='question'>Edite as informações do seu produto do jeito que quiser.</Message>
  ),
  reviewProduct: () => <ReviewMode />,
  failedMessage: () => <Message type='error'>Falha ao salvar o produto, tente novamente.</Message>,
  end: () => 'FIM!'
};

export type WizardComponent = keyof typeof wizardComponents;
